//// promise ends next frame
export const nextFrame = () => new Promise(resolve => requestAnimationFrame(resolve));
